import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getDieselUsageCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.DieselUsage}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getDieselUsageById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.DieselUsage}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertDieselUsage = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.DieselUsage,
    input
  );
  return data;
};

const updateDieselUsage = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.DieselUsage,
    input
  );
  return data;
};

const deleteDieselUsage = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DieselUsage}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useDieselUsageCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.DieselUsage],
    queryFn: () => getDieselUsageCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetDieselUsageByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.DieselUsage],
    queryFn: () => getDieselUsageById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertDieselUsageMutation = () => {
  return useMutation({
    mutationFn: insertDieselUsage,
  });
};

export const useUpdateDieselUsageMutation = () => {
  return useMutation({
    mutationFn: updateDieselUsage,
  });
};

export const useDeleteDieselUsageMutation = () => {
  return useMutation({
    mutationFn: deleteDieselUsage,
  });
};
